import { faInfoCircle } from '~/assets';
import If from '../If';
import {
  DetailItem,
  DetailKey,
  DetailValue,
  Details,
  IconComponent,
  Title,
  Value,
  ValueSection,
  ValueWarningBox,
  ValueWarningBoxText,
  Wrapper,
} from './styles';

type CreditLimitProps = {
  title: string;
  value: string;
  warningText?: string;
  details?: Record<string, string>;
};

const CreditLimit = ({
  title,
  value,
  warningText,
  details,
}: CreditLimitProps) => {
  return (
    <Wrapper>
      <ValueSection>
        <Title>{title}</Title>
        <Value>{value}</Value>
      </ValueSection>
      <If condition={!!warningText}>
        <ValueWarningBox>
          <IconComponent icon={faInfoCircle} />
          <ValueWarningBoxText>{warningText}</ValueWarningBoxText>
        </ValueWarningBox>
      </If>
      <If condition={!!details && Object.keys(details).length > 0}>
        <Details>
          {!!details &&
            Object.entries(details).map(([key, value]) => (
              <DetailItem key={key}>
                <DetailKey>{key}</DetailKey>
                <DetailValue>{value}</DetailValue>
              </DetailItem>
            ))}
        </Details>
      </If>
    </Wrapper>
  );
};

export default CreditLimit;
